/**
 * DropdownChip
 */
import { Chip } from '@material-ui/core';
import { CloseIcon } from '../Icons';
import React from 'react';
const DropdownChip = props => {
    const { label, onDelete: handleDelete, value } = props;
    const onDelete = () => {
        handleDelete(value || label);
    };
    return React.createElement(Chip, { color: "secondary", label: label, onDelete: onDelete, deleteIcon: React.createElement(CloseIcon, null) });
};
export default DropdownChip;
//# sourceMappingURL=DropdownChip.js.map